import React, {memo, useEffect, useState} from "react";
import {bindActionCreators} from 'redux';
import {useHistory, useLocation, useParams} from "react-router-dom";
import {connect} from 'react-redux';
import {
  Paper,
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio
} from '@material-ui/core';
import theme from './style';
import {useConfig} from "../../context/configContext";
import {BorderSelect} from "../../components/inputs";
import {deletePendingBatch, approvePendingBatch, fetchBatchPDF} from "../../redux/actions/invoices";
import APICall from "../../misc/APICall";
import InvoicesTable from "./InvoicesTable";
import translate from "../../misc/applyTranslation";

const InvoiceDetails = props => {
  const config = useConfig();
  const classes = theme(config);
  const history = useHistory();
  const params = useParams();
  const location = useLocation();

  const {batch} = useParams();

  const {
    access_token,
  } = props;

  const [batches, setBatches] = useState([]);
  const [page, setPage] = useState(1);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [batchInvoices, setBatchInvoices] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [showInvoiced, setShowInvoiced] = useState(location.state?.showInvoiced ?? 0);

  const handleBatchChange = e => {
    setSelectedBatch(e);
    history.replace(`/${params.lang}/invoices/details/${e}`)
  }

  const fetchBatches = (show_invoiced) => {
    const url = `invoicing/batches?page=1&limit=100&status=${show_invoiced === 1 ? "invoiced" : "batched"}`
    return APICall({
      access_token: access_token,
      url: url,
      verb: 'get',
    })
      .then(res => {
        setBatches(res.data);
        return res;
      })
  }

  const fetchBatchInvoices = (batch_id) => {
    APICall({
      access_token: access_token,
      url: `invoices?limit=${10}&page=${page}&batch_id=${batch_id}&pyramid_import_date=0`,
      verb: "get"
    })
      .then(res => {
        setBatchInvoices([...res.data]);
        setTotalPages(res.pages);
      })
  }

  const handlePagination = value => {
    setPage(value);
  }

  function formatNumberWithSpaces(number) {
    // Convert number to string
    let numStr = String(number);

    // Split the string into integer and decimal parts
    let [integerPart, decimalPart] = numStr.split(',');

    // Insert spaces every third non-decimal character in the integer part
    let formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    // Combine integer and decimal parts with a comma
    let formattedNumber = formattedIntegerPart + (decimalPart ? ',' + decimalPart : '');

    return formattedNumber;
  }

  const handleRadioChange = value => {
    setShowInvoiced(value);

    fetchBatches(value)
      .then(res => {
        const firstBatch = res.data[0]?.batch_id ?? null;

        setSelectedBatch(firstBatch);

        if (firstBatch) {
          fetchBatchInvoices(firstBatch);
          history.replace(`/${params.lang}/invoices/details/${firstBatch}`);
        } else {
          setBatchInvoices([]);
        }
      });
  };

  useEffect(() => {
    if (location.state?.showInvoiced !== undefined) {
      history.replace(location.pathname, {});
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchBatches(showInvoiced);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (batches && batches.length > 0) {
      if (batch) {
        setSelectedBatch(batch);
        fetchBatchInvoices(batch)
      } else {
        const firstBatch = batches[0].batch_id;
        setSelectedBatch(firstBatch);
        fetchBatchInvoices(firstBatch);
      }
    }
    // eslint-disable-next-line
  }, [batch, batches, page]);

  return (
    <React.Fragment>
      <Paper className={classes.paperPadding}>
        <Grid container className={classes.filterContainer}>
          <Grid item xs={12}>
            <FormControl component="fieldset">
              <RadioGroup row aria-label="type" name="position" value={showInvoiced}
                          onChange={(e) => handleRadioChange(Number(e.target.value))}>
                <FormControlLabel
                  value={0}
                  control={<Radio color="primary"/>}
                  label={translate('invoices', 'batch_not_approved')}
                  labelPlacement="start"
                />
                <FormControlLabel
                  value={1}
                  control={<Radio color="primary"/>}
                  label={translate('invoices', 'batch_approved')}
                  labelPlacement="start"
                  style={{marginLeft: '30px'}}
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item md={4}>
            {selectedBatch &&
              <BorderSelect
                onChange={e => handleBatchChange(e)}
                selected={selectedBatch}
                items={batches}
                invoiceDetailsSelect
              />
            }
          </Grid>
        </Grid>
      </Paper>
      <InvoicesTable
        classes={classes}
        batchInvoices={batchInvoices}
        formatNumberWithSpaces={formatNumberWithSpaces}
        page={page}
        totalPages={totalPages}
        handlePagination={handlePagination}
        showInvoiced={showInvoiced}
      />
    </React.Fragment>
  )
}

const mapStateToProps = store => ({
  access_token: store.login.access_token,
  refresh_token: store.login.refresh_token,
  invoicedBatches: store.invoices.invoicedBatches.data,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    deletePendingBatch,
    approvePendingBatch,
    fetchBatchPDF,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(memo(InvoiceDetails));
